import { Injectable } from "@angular/core";
import { CacheService } from "projects/core/app/services/cache.service";
import { CachedHttpService } from "projects/core/app/services/cached-http.service";
import { BaseCommonService } from "projects/core/app/services/abstracts/common.service";
import { FeatureFlagsService } from "projects/core/app/services/feature-flags.service";
import { GAService } from "projects/core/app/services/ga.service";
import { LocalisationService } from "projects/core/app/services/localisation.service";
import { LocationService } from "projects/core/app/services/location.service";
import { NavigationService } from "projects/core/app/services/navigation.service";
import { InactivityMonitorService } from "../inactivity-monitor.service";
import { BaseAuthService } from "projects/core/app/services/abstracts/auth.service";
import { BaseBrandService } from "projects/core/app/services/abstracts/brand.service";
import { BasePatientsService } from "projects/core/app/services/abstracts/patients.service";

@Injectable({
  providedIn: "root",
})
export class PatientCommonService extends BaseCommonService {
  constructor(
    _brandService: BaseBrandService,
    _patientsService: BasePatientsService,
    _authService: BaseAuthService,
    _gaService: GAService,
    _cacheService: CacheService,
    _locationService: LocationService,
    _featureFlagsService: FeatureFlagsService,
    _navigationService: NavigationService,
    _cachedHttpService: CachedHttpService,
    _localisationService: LocalisationService,
    private _inactivityMonitorService: InactivityMonitorService
  ) {
    super(
      _brandService,
      _patientsService,
      _authService,
      _gaService,
      _cacheService,
      _locationService,
      _featureFlagsService,
      _navigationService,
      _cachedHttpService,
      _localisationService
    );
  }

  protected _handleDomainInfo200(graphData: any, pathname: string): void {
    const forceSwap = pathname === "/login/redirect";
    this._authService.setPublicToken(graphData.public_jwt, forceSwap);
    super._handleDomainInfo200(graphData, pathname);
    this._inactivityMonitorService.start();
  }

  protected get allowAutocomplete(): boolean {
    return true;
  }
}
